// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"fbfd0d7ad29d3ba60cda","3":"f029817efac0b2b5afa7","4":"dbf4c8bb0f85b7365694","5":"056713dadfae6f21778b"}[chunkId] + "";
};